import { Maybe, RelatedDocument, RelatedDocumentItem } from "src/types"

/**
 * The backend only resolves a slug (via relatedDocumentsLinks/relatedProcessesLinks) for opfIds
 * it can still find, dropping unresolved ones - so opfIds and links line up by index, not by id.
 */
export const toRelatedItems = (
  opfIds: Maybe<string[]>,
  links: Maybe<RelatedDocument[]>
): RelatedDocumentItem[] =>
  (opfIds || []).map((opfId, index) => ({
    opfId,
    slug: links?.[index]?.url || "",
  }))

export const toRelatedItemOpfIds = (items: Maybe<RelatedDocumentItem[]>): string[] =>
  (items || []).map(({ opfId }) => opfId)

export const mergeRelatedItems = (
  original: Maybe<RelatedDocumentItem[]>,
  translation: Maybe<RelatedDocumentItem[]>
): RelatedDocumentItem[] => {
  const byOpfId = new Map<string, RelatedDocumentItem>()
  ;[...(original || []), ...(translation || [])].forEach((item) => byOpfId.set(item.opfId, item))
  return [...byOpfId.values()]
}
